// extracted by mini-css-extract-plugin
export var linkText = "_n8-0";